<template>
    <div>        
        <LoadingIndicator />
    </div>
</template>

<script>
    import { Globals } from '../utils/constants'
    //import jwt_decode from 'jwt-decode'
    const jwtDecode  = require('jwt-decode')

    export default {
        mounted() {
            this.$nextTick(() => {
                let token = this.getParameterByName('accessToken')                
                let redirect = this.getParameterByName('redirectTo')
                let expiresIn = parseInt(this.getParameterByName('expiresIn'))                
                let userPayload = this.tryDecodeToken(token)

                if (userPayload && !isNaN(expiresIn)) {
                    this.$store.commit('setSession', {
                        expires_in: expiresIn,
                        token: token,
                        user: userPayload
                    })

                    this.$router.push(redirect || '/')
                    //localStorage.setItem(Globals.AccessTokenKey, token)
                    //this.$router.push('/')
                }
                else {
                    console.warn('No access token, pushing to login')
                }
            })
        },
        methods: {
            getParameterByName(name) {
                let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash)
                return match && decodeURIComponent(match[1].replace(/\+/g, ' '))
            },
            tryDecodeToken(token) {
                try {
                    return jwtDecode(token)
                } catch (err) {
                    console.warn('unable to decode provided token:', token)
                    return null
                }
            }
        }
    }
</script>